// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/facilities/prefectures/:prefectureSlug/cities/:cityCode/facilities/:facilityId/reviews\",\"regex\":\"^/facilities/prefectures/([^/]+)/cities/([^/]+)/facilities/([^/]+)/reviews$\",\"paramNames\":[\"prefectureSlug\",\"cityCode\",\"facilityId\"],\"hasOptionalPrefix\":false},{\"path\":\"/mobile-app/:path*?\",\"regex\":\"^/mobile-app(?:/(.*))?$\",\"paramNames\":[\"path\"],\"hasOptionalPrefix\":false},{\"path\":\"/notifications/:notificationId\",\"regex\":\"^/notifications/([^/]+)$\",\"paramNames\":[\"notificationId\"],\"hasOptionalPrefix\":false},{\"path\":\"/rankings/:activityId\",\"regex\":\"^/rankings/([^/]+)$\",\"paramNames\":[\"activityId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/me\"},{\"path\":\"/me/email\"},{\"path\":\"/me/favorites\"},{\"path\":\"/me/notifications\"},{\"path\":\"/me/points\"},{\"path\":\"/me/points/cards\"},{\"path\":\"/me/points/receipt\"},{\"path\":\"/me/profile\"},{\"path\":\"/me/reservations\"},{\"path\":\"/me/subscription/cancel\"},{\"path\":\"/me/subscription/cancel/form\"},{\"path\":\"/corp\"},{\"path\":\"/corp/entry\"},{\"path\":\"/corp/verify\"},{\"path\":\"/awards/2025\"},{\"path\":\"/company\"},{\"path\":\"/deregistered\"},{\"path\":\"/help/email_change\"},{\"path\":\"/help/password_recovery\"},{\"path\":\"/help/password_reset\"},{\"path\":\"/law\"},{\"path\":\"/login\"},{\"path\":\"/login/two-step\"},{\"path\":\"/login/two-step/sms\"},{\"path\":\"/notifications\"},{\"path\":\"/pass\"},{\"path\":\"/pricing\"},{\"path\":\"/signup\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.2";import * as Sentry from '@sentry/nextjs'

/**
 * @type 'prod' | 'stg' | 'dev' | 'test' | 'local'
 */
const gyymEnv = process.env.NEXT_PUBLIC_GYYM_ENV ?? 'local'

/**
 * 翻訳ツールや外部タグが <head> 内の React 管理タグ(canonical/hreflang 等の
 * hoistable)を除去した状態でソフトナビゲーションが起きると、React の
 * unmountHoistable が `stateNode.parentNode.removeChild` を parentNode=null の
 * まま呼んでクラッシュする(React 本体に null ガードなし)。
 * アプリ側では防げない外部要因のため quota 保護として大半を破棄しつつ、
 * 原因特定(翻訳/autolingual/拡張機能)のため少数だけ DOM の状態タグ付きで通す。
 */
const HOISTABLE_REMOVE_CHILD_PATTERNS = [
  // WebKit: null is not an object (evaluating '(n=n.stateNode).parentNode.removeChild')
  /null is not an object \(evaluating '.*\.parentNode\.removeChild/,
  // V8: Cannot read properties of null (reading 'removeChild')
  /Cannot read properties of null \(reading 'removeChild'\)/,
  // Gecko: n.parentNode is null
  /\.parentNode is (?:null|undefined)/,
]

const HOISTABLE_CRASH_SAMPLE_RATE = 0.01

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: gyymEnv !== 'local',
  environment: gyymEnv,
  tracesSampleRate: gyymEnv !== 'prod' ? 1.0 : 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  beforeSend(event) {
    const message = event.exception?.values?.[0]?.value ?? ''
    if (!HOISTABLE_REMOVE_CHILD_PATTERNS.some((p) => p.test(message))) {
      return event
    }
    if (Math.random() >= HOISTABLE_CRASH_SAMPLE_RATE) {
      return null
    }
    try {
      const html = document.documentElement
      event.tags = {
        ...event.tags,
        hoistable_crash: true,
        'dom.lang': html.lang,
        // Chrome のページ翻訳は html 要素に translated-ltr/rtl クラスを付ける
        'dom.translated_class': /translated-(ltr|rtl)/.test(html.className),
        // Google 翻訳系はテキストノードを font 要素で二重ラップする
        'dom.font_wrap': !!document.querySelector('font font'),
        'dom.autolingual': !!document.querySelector(
          'script[src*="autolingual"]',
        ),
        'dom.canonical': !!document.querySelector('link[rel="canonical"]'),
        'dom.hreflang_count': document.querySelectorAll(
          'link[rel="alternate"][hreflang]',
        ).length,
      }
    } catch {
      // DOM 検査の失敗でイベント自体を落とさない
    }
    return event
  },
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
